module.exports = __webpack_public_path__ + "static/media/services-bg-2.1c2d32ce.png";